import { connect } from "react-redux";
import TrendFooter from "./TrendFooter";
import { applyTrendPairing, discardTrendPairing, getRaterHeatmap, getSelfVsOthers, getTopStrengthTopDev } from "../../../../../../../../../../redux/actions";
import { MATCH_MODE_KEEP_ROWS, isSameOverrides } from "../../../../constants";

// Only plain values — the two counts and whether the pairing on screen is
// ahead of the applied one — so the footer re-renders when one of those
// changes rather than on every page either table loads. The pairing itself and
// the filters come through too, since Apply re-runs the visualizations from
// them; both are references the reducer only replaces when they change.
//
// Neither call returns a compared total, but both count every leader in scope
// (totalAllLeaders) and the not-compared one counts its own exactly, so the
// compared total is the difference. Search narrows both, so this follows it.
const mapStateToProps = (state) => {
    const { fetchProjectComparisonApi, fetchProjectNotComparedApi, trendPairing } = state.BenchmarkFilteringReducer;
    const totalCount = fetchProjectNotComparedApi.totalAllLeaders || fetchProjectComparisonApi.totalAllLeaders || 0;
    return {
        totalCount,
        comparedCount: Math.max(totalCount - (fetchProjectNotComparedApi.totalLeaders || 0), 0),
        isDirty: trendPairing.matchMode !== trendPairing.applied.matchMode
            || !isSameOverrides(trendPairing.baselineOverrides, trendPairing.applied.baselineOverrides),
        matchMode: trendPairing.matchMode,
        baselineOverrides: trendPairing.baselineOverrides,
        benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    };
};

// onApply only promotes the pairing; the component pairs it with a re-run of the
// visualizations, which is why those three are here (see fetchTrendVisualizations).
const mapDispatchToProps = (dispatch) => ({
    onDiscard: () => dispatch(discardTrendPairing({ keepRows: MATCH_MODE_KEEP_ROWS })),
    onApply: () => dispatch(applyTrendPairing()),
    getRaterHeatmap: (payload) => dispatch(getRaterHeatmap(payload)),
    getSelfVsOthers: (payload) => dispatch(getSelfVsOthers(payload)),
    getTopStrengthTopDev: (payload) => dispatch(getTopStrengthTopDev(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrendFooter);
